import { render, staticRenderFns } from "./ModalFrame.vue?vue&type=template&id=09b8812d&scoped=true"
import script from "./ModalFrame.vue?vue&type=script&lang=js"
export * from "./ModalFrame.vue?vue&type=script&lang=js"
import style0 from "./ModalFrame.vue?vue&type=style&index=0&id=09b8812d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b8812d",
  null
  
)

export default component.exports